import { useState } from "react";
import { useEffect } from "react";
// import "./UserDetails.css";
import { useLocation, useNavigate } from "react-router";
// import PushNotification from "../../components/Design/Notification/PushNotification";
// import Notes from "../../components/Design/User/notes";

const UserDetails = () => {
  const [data, setData] = useState({});
  const Navigate = useNavigate();
  const location = useLocation();

  const id = location.state.data;

  useEffect(() => {
    if (id) {
      setData(id);
    }
  }, []);

  return (
    <>
      <h1 className="userdetails_heading">User Details </h1>
      <div className="userdetails">
        <div className="userdetails_up">
          <div className="userprofile_up2">
            <div className="userprofile_up_imglist">
              <img src={data.image} alt="img" />
            </div>

            <h1 className="username">{data.FirstName}</h1>
            <p className="userbio">{data.email} </p>
          </div>
        </div>
        <div className="userdetails_down">
          <p className="userdata">
            Account Create: <span> {data.createdAt}</span>
          </p>
          <p className="userdata">
            Device Type: <span> {data.deviceType}</span>
          </p>
          <p className="userdata">
            Gender: <span>{data?.gender}</span>
          </p>

          <p className="userdata">
            Date of Birth: <span>{data.dob}</span>
          </p>
          <p className="userdata">
            Age Range:{" "}
            <span>
              {data.ageRangeMin}-{data.ageRangeMax}
            </span>
          </p>
          <p className="userdata">
            Distance:{" "}
            <span>
              {data.minDistanceKm}-{data.maxDistanceKm}
            </span>
          </p>
          <p className="userdata">
            Available Now:{" "}
            <span>{data.showNowAvailable === true ? "Yes" : "No"}</span>
          </p>

          <p className="userdata">
            Profile Status:{" "}
            <span>
              {data.isCompletedProfile === false ? (
                <span className="cancel_data">Incomplete</span>
              ) : (
                <span className="complete_data">Complete</span>
              )}
            </span>
          </p>
        </div>
      </div>
      {/* <Notes isOpen={note} setisOpen={setnote} handledelete={handleaction} /> */}
      {/* {data.device_token ? (
        <div className="user_notification">
          <PushNotification id={data.device_token} />
        </div>
      ) : (
        ""
      )} */}
    </>
  );
};
export default UserDetails;
